import { Checkbox as CheckboxPrimitive } from "radix-ui";
import type * as React from "react";
import { cn } from "#/lib/utils";

const checkboxBaseClass =
	"h-4 w-4 shrink-0 rounded-[5px] border border-trade-border-subtle bg-trade-surface shadow-[inset_0_0_0_3px_var(--trade-surface-overlay)] transition-[border-color,background-color] data-[state=checked]:border-trade-accent data-[state=checked]:bg-trade-accent";

function Checkbox({
	className,
	...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
	return (
		<CheckboxPrimitive.Root
			data-slot="checkbox"
			className={cn(
				checkboxBaseClass,
				"cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-trade-accent/40 disabled:cursor-not-allowed disabled:opacity-40",
				className,
			)}
			{...props}
		/>
	);
}

type CheckboxIndicatorProps = {
	checked: boolean;
	className?: string;
};

function CheckboxIndicator({ checked, className }: CheckboxIndicatorProps) {
	return (
		<span
			aria-hidden="true"
			data-state={checked ? "checked" : "unchecked"}
			className={cn(checkboxBaseClass, className)}
		/>
	);
}

export { Checkbox, CheckboxIndicator };
